import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useSelector, useDispatch } from 'react-redux';
import CartBundleRenderer from '@components/cart/receipt/CartBundleRenderer';
import { setOthersGroupKey } from '@features/cart/cartSlice';
import { nanoid } from 'nanoid';
import { selectCartItems } from '@features/selectors/selectCartItems';

const CartReceiptBody = ({ minicart }) => {
	const dispatch = useDispatch();
	const splitItems = useSelector(selectCartItems);

	useEffect(() => {
		const othersGroupKey = Object.keys(splitItems.others).length ? Object.keys(splitItems.others)[0] : nanoid();
		dispatch(setOthersGroupKey(othersGroupKey));
	}, []);

	return (
		<section data-test='recommended-items' id='itemsRoot' className='items'>
			<CartBundleRenderer group={splitItems.bases} minicart={minicart} />
			<CartBundleRenderer group={splitItems.others} isOthersGroup minicart={minicart} />
		</section>
	);
};

CartReceiptBody.propTypes = {
	minicart: PropTypes.bool,
};

CartReceiptBody.defaultProps = {
	minicart: false,
};

export default CartReceiptBody;
